import styled from 'styled-components';

const HeroIndividualServiceStyle = styled.section`
	--sizeImage: 40%;

	margin-bottom: var(--sectionDistance);

	.title-service-hero {
		opacity: 0;
		transition-delay: 0.5s;
	}

	.image-text-wrapper {
		position: relative;

		.image-cont {
			--proportion: var(--sizeImage);

			transform: scale(0);
			transition: calc(var(--trTime) * 2) ease-in-out;

			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				z-index: 1;
				width: 100%;
				height: 100%;
				background-color: var(--black);
				opacity: 0.2;
			}
		}

		.wrapper-info {
			position: absolute;
			bottom: 0;
			left: 0;
			padding-bottom: var(--customDistance2);
			z-index: 1;

			.title-service-hero {
				color: var(--white);

				/* text-shadow: 1px 2px 3px var(--backgroundSecondaryColor); */
			}
		}
	}

	&.active {
		.image-text-wrapper {
			.image-cont {
				transform: scale(1);
			}
		}

		.title-service-hero {
			opacity: 1;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeImage: 40%;
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--sizeImage: 40%;
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeImage: 35%;
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeImage: 50%;
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeImage: 45%;
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeImage: 130%;
	}
`;
export default HeroIndividualServiceStyle;
